import { PolicyModel } from './policy.model';

export class RolePolicyModel {
  id!: number;
  policy_id!: number;
  role_id!: number;
  create!: boolean;
  read!: boolean;
  update!: boolean;
  delete!: boolean;
  created_at?: string;
  updated_at?: string;
  policy?: PolicyModel;

  constructor(data?: Partial<RolePolicyModel>) {
    if (data) {
      this.policy = new PolicyModel(data.policy);
      Object.assign(this, data);
    }
  }

  hasPermission(permission: string): boolean {
    return !!this[permission as keyof Omit<this, 'hasPermission'>];
  }

  // Métodos para setear permisos
 /* setCreate(value: boolean) {
    this.create = value;
  }

  setRead(value: boolean) {
    this.read = value;
  }

  setUpdate(value: boolean) {
    this.update = value;
  }

  setDelete(value: boolean) {
    this.delete = value;
  }*/
}